module.exports = __webpack_public_path__ + "img/update-white.71d06cb5.svg";